import Toolbar from '@mui/material/Toolbar';
import logo from '../assets/images/logos/logo_transparent.png';
import LanguageMenu from '@pok/weblib/ui/LanguageMenu.jsx';
import Stack from '@mui/material/Stack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default function PokToolbar() {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const isAcceptScreen = location.pathname.startsWith('/accept');
    return (
        <>
            {!isAcceptScreen && (
                <Toolbar
                    variant="dense"
                    id="pok-toolbar"
                    sx={{
                        backgroundColor: 'primary.main',
                        boxShadow: '0px 0px 10px 4px rgba(0, 0, 0, 0.25)',
                        color: '#FFFFFF',
                        height: 60,
                    }}
                >
                    <Stack
                        direction="row"
                        spacing={2}
                        ml={3}
                        mr={1}
                        width={'100%'}
                        alignItems={'center'}
                        marginTop={'0px !important'}
                        justifyContent={'space-between'}
                    >
                        <img src={logo} alt="logo" height={32} id="pok-toolbar-img" />

                        <LanguageMenu wallet={undefined} t={t} i18n={i18n} />
                    </Stack>
                </Toolbar>
            )}
        </>
    );
}
